import { InputForm, Error, SubmitButton } from "components";
import { CommercialTotalUserDataInput } from "modules/report/dcdd_report/state/actionType";
import {
    DateRangeInputError,
} from "modules/user_management/dcdd_user/users/state/actionType";

interface Props {
    formData: CommercialTotalUserDataInput;
    error: DateRangeInputError;
    loading: boolean;
    onClose?: () => void;
    handleChange: (
        e: React.ChangeEvent<HTMLInputElement>
    ) => void;
    handleSubmit: React.MouseEventHandler<HTMLButtonElement>;
}
const DateRangeForm: React.FC<Props> = ({
    handleChange,
    handleSubmit,
    error,
    formData,
    loading,
}) => {
    return (
        <>
            <form>
                <div className="flex gap-4 items-end">
                    <div>
                        <InputForm
                            label="From Date"
                            id="from_date"
                            name="from_date"
                            type="date"
                            value={formData.from_date}
                            onChange={handleChange}
                        />
                        {error.fromDate && <Error>{error.fromDate}</Error>}
                    </div>
                    <div>
                        <InputForm
                            label="To Date"
                            id="to_date"
                            name="to_date"
                            type="date"
                            value={formData.to_date}
                            onChange={handleChange}
                        />
                        {error.toDate && <Error>{error.toDate}</Error>}
                    </div>
                    <div className="pb-3">
                        <SubmitButton
                            onClick={handleSubmit}
                            loading={loading}
                            loadingText="Searching..."
                        >
                            Search
                        </SubmitButton>
                    </div>
                </div>
            </form>

        </>
    );
};
export default DateRangeForm;
